import React from 'react';
import { History } from 'history';
import {
    LessonData,
    AudioLessonData,
    WritingLessonData,
    PageLayout,
    Identifier,
    VideoLessonData,
} from '../../types';
import AudioPlayer from './AudioPlayer';
import WritingLesson from './WritingLesson';
import PageBack from '../../components/PageBack';
import PageTitle from '../../components/PageTitle';
import PageLayoutComponent from '../../components/PageLayout';
import LinkManager from '../../lib/LinkManager';
import VideoLesson from './VideoLesson';

type Props = {
    mentalPageLayout: PageLayout,
    lesson: LessonData,
    lessonId: Identifier,
    history: History,
    isFromFavorites: boolean,
}

export default ({
    mentalPageLayout,
    lesson,
    lessonId,
    history,
    isFromFavorites,
}: Props) => {
    let renderedLesson;

    if (lesson.art === 'audio') {
        // const audioLayout = mentalApi.getMentalAudioLayout(mental.mentalId);
        const audioLesson: AudioLessonData = lesson;
        renderedLesson = (
            <AudioPlayer
                lesson={audioLesson}
                lessonId={lessonId}
                // We need to ignore here because LocationDescriptor<any> does not match any
                // method signature. I reality it always does match one.
                // @ts-ignore
                // eslint-disable-next-line react/jsx-props-no-multi-spaces
                onNativePlayer={() => history.push(lesson.parentLink)}
            />
        );
    } else if (lesson.art === 'schrift') {
        const writingLesson: WritingLessonData = lesson;
        renderedLesson = (<WritingLesson lesson={writingLesson} />);
    } else if (lesson.art === 'video') {
        const videoLesson: VideoLessonData = lesson;
        renderedLesson = (<VideoLesson lesson={videoLesson} />);
    }

    const backlink = isFromFavorites
        ? LinkManager.getFavoritesLink()
        : lesson.parentLink;

    return (
        <div>
            <PageLayoutComponent layout={mentalPageLayout} />
            <PageBack backlink={backlink} />
            <PageTitle documentTitleParts={[lesson.mentalTitle, lesson.title]}>
                <span className="mobile-parent-title">
                    {lesson.mentalTitle.length > 20 ? `${lesson.mentalTitle.substring(0, 20)}...` : lesson.mentalTitle}
                </span>
                <span className="parent-title">{lesson.mentalTitle}</span>
                <strong>{lesson.title}</strong>
            </PageTitle>
            {renderedLesson}
        </div>
    );
};
